import { ReactElement } from 'react';
import { FormikContextType } from 'formik';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Switch from '@mui/material/Switch';
import { useEffect } from 'react';
import { Headline6 } from '../../../../components/UI/MDC/Typography/Typography';
import withComponentLoader from '../../../../hoc/withComponentLoader';
import AppWrappedInput from './AppWrappedInput';
import RequiredIndicator from './RequiredIndicator';

/**
 * Switch (Toggle) base component stylized to work with Custom App Request Form
 * @param {Object} props component properties
 * @param {Function} props.setLoading setter function coming from `withComponentLoader` HOC
 * @param {string} props.label display text
 * @param {FormikContextType} props.formik full Formik Context
 * @param {string|ReactElement} props.helperText helper text
 * @param {boolean} props.disabled flag to indicate whether input is disabled
 * @param {Function} props.customOnChange optional `onChange` handler to be called with native `onChange`
 * @param {boolean} props.isRequired flag to determine whether to show required indicator
 * @param {boolean} props.isLoading flag to indicate the loading state (comes from parent)
 * @param {object} props.props the rest of the props
 * @returns Switch input stylized for custom
 */
const AppWrappedSwitch = ({
	setLoading,
	label,
	formik,
	helperText,
	disabled,
	customOnChange,
	isRequired = false,
	isLoading = false,
	...props
}) => {
	useEffect(() => {
		setLoading(isLoading);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLoading]);

	return (
		<AppWrappedInput
			noIndent
			error={
				formik.touched[props.name] ? formik.errors[props.name] : null
			}
		>
			<FormControl variant='filled' fullWidth>
				<FormControlLabel
					control={
						<Switch
							name={props.name}
							onChange={e => {
								customOnChange && customOnChange(e);
								formik.setFieldValue(
									props.name,
									e.target.checked
								);
							}}
							onBlur={formik.handleBlur}
							disabled={disabled}
							checked={formik.values[props.name]}
						/>
					}
					label={
						<Headline6>
							{isRequired ? <RequiredIndicator /> : null}
							{label}
						</Headline6>
					}
				/>
				<FormHelperText>{helperText}</FormHelperText>
			</FormControl>
		</AppWrappedInput>
	);
};
export default withComponentLoader(AppWrappedSwitch);
